/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React from 'react';
import { Grid } from '@mui/material';
import LoadingOverlay from '../../../../Components/LoadingOverlay';
import FormFieldSkeleton from '../../../../Components/Skeleton/FormFieldSkeleton';

/**
 * Contract form element skeleton
 * @returns {JSX.Element}
 * @constructor
 */
export default function ContractFormSkeleton() {
  return (
    <>
      <LoadingOverlay />
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
    </>
  );
}
